import { ApiUrls } from '../ApiUrls';
import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { ILink } from './linksInterfaces';

export async function deleteLink(linkId: number): Promise<void> {
  try {
    await httpService.delete(ApiUrls.link(linkId));
  } catch (e) {
    throw e;
  }
}

export async function fetchLinks(type: string): Promise<ILink[]> {
  try {
    const response = await httpService.get(ApiUrls.links(type));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function updateLink(link: ILink): Promise<IEntityWithMessages<ILink>> {
  try {
    const response = await httpService.post(ApiUrls.links(), link);
    return await response.json();
  } catch (e) {
    throw e;
  }
}
